"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Icon: function() {
        return _Icon.Icon;
    },
    Provider: function() {
        return _IconProvider.IconProvider;
    },
    Selector: function() {
        return _IconSelector.IconSelector;
    }
});
const _IconProvider = require("./IconProvider");
const _Icon = require("./Icon");
const _IconSelector = require("./IconSelector");

//# sourceMappingURL=index.js.map